import React, { useState } from "react";
import OtpInput from "react-otp-input";
import { connect } from "react-redux";
import { CustomButton } from "../../../../../components/customButton/CustomButton";
import { LIGHT_GREY_BG_MODAL } from "../../../../../resources/colorsManager";

function BeneficiarySendOtp({
  beneficiaryDetails,
  onClickConfirm,
  loading = false,
  profileDetails,
}) {
  const [step, setStep] = useState(0);
  const [otp, setOtp] = useState("");
  const [disabled, setDisabled] = useState(true);

  const pStyle = {
    padding: 0,
    margin: 0,
    fontSize: 16,
    color: LIGHT_GREY_BG_MODAL,
    color: "#c0c0c0",
    textAlign: "center",
    margin: "20px 0px",
  };

  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        flex: 1,
      }}
    >
      <div
        style={{
          height: "100%",
        }}
      >
        <p
          style={{
            ...pStyle,
          }}
        >
          {`Enter the OTP sent to ${profileDetails?.mobileNumber}`}
        </p>
        <OtpInput
          containerStyle={{
            width: "100%",
            display: "flex",
            justifyContent: "space-evenly",
          }}
          inputStyle={{
            width: 40,
            height: 40,
            backgroundColor: "#ffffff",
            border: "1px solid #efefef",
            borderRadius: 5,
          }}
          value={otp}
          onChange={(val) => {
            if (/^[0-9]+$/.test(val) && val.length <= 6) {
              setOtp(val);
            } else {
              setOtp("");
            }
          }}
          numInputs={6}
          separator={<span> - </span>}
        />
      </div>

      <CustomButton
        disabled={otp.length === 6 ? false : true}
        title="Submit"
        onClick={() => {
          onClickConfirm(otp);
        }}
        styles={{
          width: "100%",
          marginTop: 40,
          border: "none",
          height: 45,
          borderRadius: 4,
          marginBottom: 20,
        }}
        loading={loading}
      />
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    profileDetails: state.profileDetailsReducer.details,
  };
};
export default connect(mapStateToProps)(BeneficiarySendOtp);
